import * as React from 'react';
import * as NotificationApi from '@mam/main/Api/Pigeon/NotificationEmailHtmlBody';
import { useApiResult } from '@mam/main/ApiHooks';
import { useSearchParams } from '@mam/main/Router';

export const NotificationEmailDetail: React.FunctionComponent = () => {
	const params = useSearchParams();
	const notificationId = params.get('notificationId') ?? '';
	const notificationEmailId = params.get('emailNotificationId') ?? '';

	const [requestResult] = useApiResult<
		NotificationApi.NotificationEmailHtmlBodyRequest,
		string,
		NotificationApi.NotificationEmailHtmlBodyError
	>(new NotificationApi.NotificationEmailHtmlBodyRequest(notificationId, notificationEmailId), [
		notificationId,
		notificationEmailId,
	]);

	if (requestResult.isLoading || requestResult.value === null) {
		return <></>;
	}

	return <div dangerouslySetInnerHTML={{ __html: requestResult.value }} />;
};
